<template>
  <section class="wrapper">
    <app-header :user="auth_user"></app-header>
    <app-sidebar @openUpload="prepareUpload()"></app-sidebar>
    <!-- Content Wrapper -->
    <div class="content-wrapper bg-white">
      <app-main></app-main>
      <m-logout></m-logout>
    </div>
    <app-footer class="no-print pt-5 bg-white"></app-footer>
    <!-- Add the sidebar's background. This div must be placed
		immediately after the control sidebar -->
    <div class="control-sidebar-bg"></div>
  </section>
</template>
<script>
  import AppHeader from './partials/Header.vue';
  import AppSidebar from './partials/Sidebar.vue';
  import AppFooter from './partials/Footer.vue';
  import AppMain from './AppMain.vue';
  import mLogout from '../components/m-logout.vue';
  import Cookies from 'js-cookie';
  export default {
    name: 'Layout',
    components: {
      AppHeader,
      AppSidebar,
      AppFooter,
      AppMain,
      mLogout
    },
    computed: {
      id() {
        return this.$store.state.user.id;
      },
    },
    watch: {
      id: function () {
        this.changeLayout();
      }
    },
    beforeMount() {
      this.$store.dispatch('getUserData');
      this.changeLayout();
      const hasConfig = Cookies.get(btoa('company_config_api_key'));
      if (hasConfig) {
        if (!this.userConfig.company_id) {
          this.getConfig(hasConfig);
        }
        return;
      } else {
        if (!this.$route.params.lojaUrl) {
          this.$router.push('/invalid-url');
          return;
        }
        this.getConfig(this.auth_user.fk_user_id);
      }
    },
    methods: {
      prepareUpload() {
        this.$refs.mUpload.showModal();
      },
      changeLayout() {
        this.$root.$i18n.locale = this.$store.state.user.localSettings.user_language;
        this.$root.$validator.locale = this.$store.state.user.localSettings.user_language;
        this.getLayout();
      },
      getConfig(hasConfig) {       
        this.$store.dispatch('getConfig', hasConfig).then(response => {
          console.log(response)
          this.$store.commit('SET_USER_CONFIG', response, );
          Cookies.set(btoa('company_config_api_key'), response.company_id, {
            expires: 365
          });
        }).catch(error => {
          console.log(error)
          this.$router.push('/invalid-url');
        }).finally(() => {
        })
      },
    }
  };
</script>
<style>
  .grecaptcha-badge {
    visibility: hidden;
  }
</style>